import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import * as geoViewport from '@mapbox/geo-viewport';
import * as mapbox from 'mapbox-gl';
import { SettlementStatementOrderDetail } from 'src/app/types';

@Component({
  selector: 'lohi-settlement-order-map',
  templateUrl: './settlement-order-map.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SettlementOrderMapComponent implements OnInit {
  @Input() public order: SettlementStatementOrderDetail;
  public mapUrl: string;

  constructor() {}

  public ngOnInit(): void {
    this.mapUrl = getMapboxLink(this.order);
  }
}

function getMapboxLink(order: SettlementStatementOrderDetail): string {
  if (!order) {
    return null;
  }
  const bounds = new mapbox.LngLatBounds();
  bounds.extend(order.pickupLocation.lngLat);
  bounds.extend(order.dropoffLocation.lngLat);
  const viewport = geoViewport.viewport(
    [bounds.getWest(), bounds.getSouth(), bounds.getEast(), bounds.getNorth()],
    [1200, 600],
  );

  let url = `https://api.mapbox.com/styles/v1/mapbox/streets-v11/static/url-https%3A%2F%2Fstorage.googleapis.com%2Flohi_public%2Forigin.png(${
    order.pickupLocation.lngLat[0]
  },${order.pickupLocation.lngLat[1]}),url-https%3A%2F%2Fstorage.googleapis.com%2Flohi_public%2Fdestination.png(${
    order.dropoffLocation.lngLat[0]
  },${order.dropoffLocation.lngLat[1]})/${viewport.center.join(',')},${viewport.zoom - 1},0/1200x600@2x`;
  url = `${url}?access_token=pk.eyJ1Ijoic2F0ZXN0ZGV2IiwiYSI6ImNrYmVraDllZDBtcXQycHFlbzVqYXk0cnMifQ.HzVySDvy0mLDW03ykD2HNw`;
  return url;
}
